import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { lazy, Suspense } from "react";
import CircularLoading from "../components/CircularLoading";

// Lazy load components for better performance
const AppInformation = lazy(() => import("./AppInformation"));
const GeneralSettings = lazy(() => import("./GeneralSettings"));
const LanguageSetting = lazy(() => import("./LanguageSetting"));
const PaymentSettings = lazy(() => import("./PaymentSettings"));
const SmtpSettings = lazy(() => import("./SmtpSettings"));
const AddOnSettings = lazy(() => import("./AddOnSettings"));
const AdminQueueAddOnSettings = lazy(() => import("./AdminQueueAddOnSettings"));
const PointConversionSettings = lazy(() => import("./PointConversionSettings"));
const PredefinedFeedbackSettings = lazy(() =>
	import("./PredefinedFeedbackSettings")
);

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	// Only render the active tab's content
	if (value !== index) {
		return null;
	}

	return (
		<div
			role='tabpanel'
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			<Box sx={{ p: 3 }}>
				<Suspense fallback={<CircularLoading />}>
					<div>{children}</div>
				</Suspense>
			</Box>
		</div>
	);
}

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

export default function Settings() {
	const [value, setValue] = React.useState(0);
	const { t } = useTranslation();

	// Get settings data from Redux to check add-on status
	const settingsdata = useSelector((state) => state.settingsdata);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%" }}>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label='basic tabs example'
					variant='scrollable'
					scrollButtons='auto'
					allowScrollButtonsMobile
					sx={{
						"& .MuiTabs-scrollButtons": {
							"&.Mui-disabled": {
								opacity: 0.3,
							},
						},
					}}
				>
					<Tab
						label={t("app_info")}
						{...a11yProps(0)}
						sx={{
							minWidth: "auto",
							padding: "12px 16px",
							marginRight: "8px",
							whiteSpace: "nowrap",
						}}
					/>
					<Tab
						label={t("general_settings")}
						{...a11yProps(1)}
						sx={{
							minWidth: "auto",
							padding: "12px 16px",
							marginRight: "8px",
							whiteSpace: "nowrap",
						}}
					/>
					<Tab
						label={t("payment_settings")}
						{...a11yProps(2)}
						sx={{
							minWidth: "auto",
							padding: "12px 16px",
							marginRight: "8px",
							whiteSpace: "nowrap",
						}}
					/>
					<Tab
						label={t("language")}
						{...a11yProps(3)}
						sx={{
							minWidth: "auto",
							padding: "12px 16px",
							marginRight: "8px",
							whiteSpace: "nowrap",
						}}
					/>
					<Tab
						label={t("smtpsettings")}
						{...a11yProps(4)}
						sx={{
							minWidth: "auto",
							padding: "12px 16px",
							marginRight: "8px",
							whiteSpace: "nowrap",
						}}
					/>
					<Tab
						label={t("add_on")}
						{...a11yProps(5)}
						sx={{
							minWidth: "auto",
							padding: "12px 16px",
							marginRight: "8px",
							whiteSpace: "nowrap",
						}}
					/>
					<Tab
						label={t("point_conversion_settings")}
						{...a11yProps(6)}
						sx={{
							minWidth: "auto",
							padding: "12px 16px",
							marginRight: "8px",
							whiteSpace: "nowrap",
						}}
					/>
				</Tabs>
			</Box>
			<TabPanel value={value} index={0}>
				<AppInformation />
			</TabPanel>
			<TabPanel value={value} index={1}>
				<GeneralSettings />
			</TabPanel>
			<TabPanel value={value} index={2}>
				<PaymentSettings />
			</TabPanel>
			<TabPanel value={value} index={3}>
				<LanguageSetting />
			</TabPanel>
			<TabPanel value={value} index={4}>
				<SmtpSettings />
			</TabPanel>
			<TabPanel value={value} index={5}>
				<AddOnSettings />
			</TabPanel>
			<TabPanel value={value} index={6}>
				<PointConversionSettings />
			</TabPanel>
		</Box>
	);
}
